// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0766d07e","413":"eed7c498","703":"38afca75","945":"c2d55ab9"}[chunkId] + ".chunk.js";
};